import { Action } from '@ngrx/store';

import { ContractHistoryResponse, ContractType } from '@app-model/api';
import { HistoryFilter } from '@app-model/history-filter';

/**
 * When User initially visits our page, UI will
 * get all images and css
 */

export const GET_CONTRACTS = '[History] GET CONTRACTS';
export const GET_CONTRACTS_SUCCESS = '[History] GET CONTRACTS SUCCESS';
export const UNDO_DECLINE_CONTRACT = '[History] UNDO DECLINE CONTRACT';
export const UNDO_DECLINE_CONTRACT_SUCCESS = '[History] UNDO DECLINE CONTRACT SUCCESS';

export const FILTER_GRID = '[History] FILTER GRID';

export const HISTORY_FAILURE = '[History] HISTORY FAILURE';

export class GetContractsAction implements Action {
  readonly type = GET_CONTRACTS;

  constructor(public payload: { firstName: string; lastName: string; vin: string } = { firstName: '', lastName: '', vin: '' }) {
  }
}

export class GetContractsSuccessAction implements Action {
  readonly type = GET_CONTRACTS_SUCCESS;

  constructor(public payload: { contracts: ContractHistoryResponse; filters: HistoryFilter }) {
  }
}

export class FilterGridAction implements Action {
  readonly type = FILTER_GRID;

  constructor(public payload: HistoryFilter) {
  }
}

export class UndoDeclineContractAction implements Action {
  readonly type = UNDO_DECLINE_CONTRACT;

  constructor(public payload: ContractType) {
  }
}

export class UndoDeclineContractSuccessAction implements Action {
  readonly type = UNDO_DECLINE_CONTRACT_SUCCESS;

  constructor(public payload: { contracts: ContractType[]; filters: HistoryFilter }) {
  }
}

/////////////////////////////////////////////////////////////////////////

export class HistoryFailureAction implements Action {
  readonly type = HISTORY_FAILURE;
}

export type All =
  | GetContractsAction
  | GetContractsSuccessAction
  | UndoDeclineContractAction
  | UndoDeclineContractSuccessAction
  | FilterGridAction
  | HistoryFailureAction;
